import React from "react";
import ActionButtons from "../../../components/ui/popups/ActionButtons";
import { leaveOrgMessage } from "../../../services/orgRelationship";

// Confirm leaving an HME (ACDPA-315). Uses the themed ActionButtons popup, like the other org
// flows (the share confirmation it once mirrored, ShareOrgConfirm, was removed by F-524).
//
// ⛔ Deliberately NOT phrased as an agreement. ShareOrgConfirm said "I Agree" because sharing
// GRANTS access and the wording is the consent. Leaving REVOKES it, and the kernel records no
// wording version for this action — so the copy states consequences plainly and claims no
// legal weight the backend is not capturing. The wording lives in `leaveOrgMessage` so it is
// testable without Ionic (IonModal children never render under jsdom).
type Props = {
  /** Label of the org being left, or null when the modal is closed. */
  orgLabel: string | null;
  busy?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
};

const LeaveOrgConfirm: React.FC<Props> = ({ orgLabel, busy, onConfirm, onCancel }) => (
  <ActionButtons
    isOpen={!!orgLabel}
    onClose={onCancel}
    title="Leave this organization?"
    message={orgLabel ? leaveOrgMessage(orgLabel) : ""}
    actionButtons={[
      {
        text: busy ? "Leaving…" : "Leave",
        isPrimary: true,
        action: async () => {
          await onConfirm();
        },
      },
      { text: "Cancel", action: onCancel },
    ]}
  />
);

export default LeaveOrgConfirm;
